import { Button } from 'antd';
import DefaultModal from 'components/common/DefaultModal';
import CommonTransactionForm from 'components/CommonTransactionForm';
import React, { useCallback, useState } from 'react';
import { AddIconStyled, InviteButtonContainerStyled } from 'routes/Users/components/CreateUserModal/styled';
import { ILocation } from 'types/location';
import { ITransactionType } from 'types/services';

const CreateTransactionButtonWithTransactionModal: React.FC<{
  loading?: boolean;
  locations?: ILocation[];
  transactionTypes?: ITransactionType[];
}> = ({ locations, loading, transactionTypes }) => {
  const [transactionFormModalVisible, setTransactionFormModalVisible] = useState(false);
  const onCreateTransactionButtonClick = useCallback(() => {
    // setVisible(true);
    setTransactionFormModalVisible(true);
  }, []);

  const closeTransactionModal = () => {
    setTransactionFormModalVisible(false);
  };

  return (
    <>
      <DefaultModal
        props={{
          visible: transactionFormModalVisible,
          title: 'Create Transaction',
          onCancel: closeTransactionModal,
          destroyOnClose: true,
        }}>
        <CommonTransactionForm
          transactionTypes={transactionTypes}
          locations={locations}
          closeForm={closeTransactionModal}
          loading={loading}
        />
      </DefaultModal>
      <div>
        <Button className='gx-pulse-effect gx-m-0' type='primary' onClick={onCreateTransactionButtonClick}>
          <InviteButtonContainerStyled>
            <AddIconStyled> + </AddIconStyled>
            <span>Transaction</span>
          </InviteButtonContainerStyled>
        </Button>
      </div>
    </>
  );
};

export default React.memo(CreateTransactionButtonWithTransactionModal);
